import React, { ComponentProps } from 'react';
import { TitleImage } from '../../../types/api/ImageType';
import IForm from '../../../types/IForm';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { AspectRatioOption, ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';

type TitleImageEditProps = {
  image: TitleImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: IForm;
  userSelectableAspectRatios?: AspectRatioOption[];
};

export function TitleImageEdit({
  image,
  form,
  cropping,
  viewportSwitch,
  userSelectableAspectRatios,
}: TitleImageEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('TitleImage');

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      cropping={cropping}
      viewportSwitch={viewportSwitch}
      form={form}
      formId="title-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
      userSelectableAspectRatios={userSelectableAspectRatios}
    />
  );
}

export const TitleImageEditView = asFetchableView(TitleImageEdit);
export type TitleImageEditView = ComponentProps<typeof TitleImageEditView>;
